import { render, staticRenderFns } from "./Bilde.vue?vue&type=template&id=d6570d1c&"
import script from "./Bilde.vue?vue&type=script&lang=js&"
export * from "./Bilde.vue?vue&type=script&lang=js&"
import style0 from "./Bilde.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports